
	import QuestionFirst from './questions/QuestionFirst';
	import QuestionSecond from './questions/QuestionSecond';
	import QuestionThird from './questions/QuestionThird';
	import QuestionFourth from './questions/QuestionFourth';
	import QuestionResult from './questions/QuestionResult';
	import LearnMoreTest from './questions/LearnMoreTest';

	export default {
		components: {
			QuestionFirst,
			QuestionSecond,
			QuestionThird,
			QuestionFourth,
			QuestionResult,
			LearnMoreTest
		},
		data() {
			return {
				componentKey: 0,
				debug: false,
				learnMore: false,
				risk: null,

				checkboxesSelected: [],

				answers: {
					isQuestionSecond: false,
					isQuestionThird: false,
					isQuestionFourth: false,
					questionFirst: [],
					questionSecond: [],
					questionThird: {},
					questionFourth: [],
				},

				rulesSecondStep: {
					DM: false,
					Obesity: false
				},

				rulesThirdStep: {
			        age: false,
			        sex: false,
			        C2VScore: false,
			        egfr: false,
			        albuminuria: false,
			        k: false,
			        ldlc: false,
			        scr: false,
			        ef: false,
			    },

			    rulesFourthStep: {
			        Anticoagulant: false,
					"ACEi/ARB": false,
					SGLTi: false,
					"GLP1-RA": false,
					nsMRA: false,
					Statin: false,
					"Additional LLT": false,
					"Evi. Based BB >50% max Dose": false,
					"Evi. Based BB <50% max Dose": false,
					ARNI: false,
					sMRA: false,
					BetaBlocker: false,
			    },

			    score: {
			    	score_aff: {min: 0, max: 0},
			    	score_ckd: {min: 0, max: 0},
			    	score_ascvd: {min: 0, max: 0},
			    	score_hf: {min: 0, max: 0},
			    	risk: 0,
			    	helper: 0,
			    },

			    errors: {
			    	age: false,
			    	sex: false,
			    	C2VScore: false,
			    	k: false,
			    	scr: false,
					egfr: false,
			    }
			}
		},
		computed: {
		    hasAnswers() {
		        return (
		            this.answers.questionFirst.length > 0 ||
		            this.answers.questionSecond.length > 0 ||
		            Object.keys(this.answers.questionThird).length > 0 ||
		            this.answers.questionFourth.length > 0 ||
		            this.answers.isQuestionSecond ||
		            this.answers.isQuestionThird ||
		            this.answers.isQuestionFourth
		        );
		    }
		},
		methods: {
			run(event) {
				this.setRules();
				this.calculate();
			},
			startOver() {
				Object.assign(this.$data, this.$options.data());
				this.componentKey++;
			},
			isRuleEnabled(ruleName) {
				const rule = this.rulesThirdStep.find(r => r.name == ruleName);
				return rule && rule.condition;
			},
			setRuleCondition(rulesObj, ruleName, value) {
			    this.$set(rulesObj, ruleName, value);
			},
			isValidNumber(number) {
				if (number === null || number === undefined) {
				    return undefined;
				}

				return number === '' || isNaN(+number) ? 0 : +number;
			},
			setRules() {
				const questionFirst = this.answers.questionFirst;
				const questionSecond = this.answers.questionSecond;

				Object.keys(this.rulesSecondStep).forEach(key => {
				    this.$set(this.rulesSecondStep, key, false);
				});
				Object.keys(this.rulesThirdStep).forEach(key => {
				    this.$set(this.rulesThirdStep, key, false);
				});
				Object.keys(this.rulesFourthStep).forEach(key => {
				    this.$set(this.rulesFourthStep, key, false);
				});

				const q1 = this.answers.questionFirst;
				const q2 = this.answers.questionSecond;
				
				if (q1.includes('AFF')) {
					this.rulesThirdStep.age = true;
					this.rulesThirdStep.sex = true;
					this.rulesThirdStep.C2VScore = true;
					this.rulesFourthStep.Anticoagulant = true;
				}

				if (q1.includes('Chronic Kidney Disease')) {
					this.rulesThirdStep.egfr = true;
					this.rulesThirdStep.albuminuria = true;
					this.rulesFourthStep['ACEi/ARB'] = true;
					this.rulesFourthStep.ARNI = true;
					this.rulesFourthStep.SGLTi = true;
					this.rulesFourthStep['GLP1-RA'] = true;
					this.rulesFourthStep.nsMRA = true;
				}

				if (q1.includes('ASCVD')) {
					this.rulesSecondStep.DM = true;
					this.rulesSecondStep.Obesity = true;
					this.rulesThirdStep.age = true;
					this.rulesThirdStep.sex = true;
					this.rulesThirdStep.egfr = false;
					this.rulesFourthStep['GLP1-RA'] = false;
					this.rulesFourthStep.SGLTi = false;
					this.rulesThirdStep.ldlc = false;
					this.rulesFourthStep.Statin = false;
					this.rulesFourthStep['Additional LLT'] = false;

					if (q1.includes('Chronic Kidney Disease')) {
						this.rulesThirdStep.egfr = true;
					}

					if (!q2.includes('DM') && !q2.includes('Obesity')) {
						this.rulesThirdStep.ldlc = true;
						this.rulesFourthStep.Statin = true;
						this.rulesFourthStep['Additional LLT'] = true;
					}

					if (q2.includes('DM') && q2.includes('Obesity')) {
						this.rulesThirdStep.egfr = true;
						this.rulesThirdStep.ldlc = true;
						this.rulesFourthStep.Statin = true;
						this.rulesFourthStep['Additional LLT'] = true;
						this.rulesFourthStep['GLP1-RA'] = true;
						this.rulesFourthStep.SGLTi = true;
					}

					if (q2.includes('DM') && !q2.includes('Obesity')) {
						this.rulesThirdStep.egfr = true;
						this.rulesThirdStep.ldlc = true;
						this.rulesFourthStep.Statin = true;
						this.rulesFourthStep['Additional LLT'] = true;
						this.rulesFourthStep['GLP1-RA'] = true;
						this.rulesFourthStep.SGLTi = true;
					}

					if (!q2.includes('DM') && q2.includes('Obesity')) {
						this.rulesThirdStep.egfr = true;
						this.rulesThirdStep.ldlc = true;
						this.rulesFourthStep.Statin = true;
						this.rulesFourthStep['Additional LLT'] = true;
						this.rulesFourthStep['GLP1-RA'] = true;
					}
				}

				if (q1.includes('HFrEF/HFmrEF') || q1.includes('HFpEF')) {
					this.rulesSecondStep.DM = false;
					this.rulesSecondStep.Obesity = true;
					this.rulesThirdStep.age = true;
					this.rulesThirdStep.sex = true;
					this.rulesThirdStep.egfr = true;
					this.rulesThirdStep.scr = true;
					this.rulesThirdStep.k = true;
					this.rulesThirdStep.ef = false;
					this.rulesFourthStep['Evi. Based BB >50% max Dose'] = false;
					this.rulesFourthStep['Evi. Based BB <50% max Dose'] = false;
					this.rulesFourthStep['ACEi/ARB'] = false;
					this.rulesFourthStep.ARNI = false;
					this.rulesFourthStep.SGLTi = false;
					this.rulesFourthStep.sMRA = false;
					this.rulesFourthStep.nsMRA = false;
					this.rulesFourthStep['GLP1-RA'] = false;
					this.rulesFourthStep.BetaBlocker = true;


					if (q1.includes('HFrEF/HFmrEF') && !q2.includes('Obesity')) {
						this.rulesFourthStep['Evi. Based BB >50% max Dose'] = true;
						this.rulesFourthStep['Evi. Based BB <50% max Dose'] = true;
						this.rulesFourthStep['ACEi/ARB'] = true;
						this.rulesFourthStep.ARNI = true;
						this.rulesFourthStep.SGLTi = true;
						this.rulesFourthStep.sMRA = true;
					}

					if (q1.includes('HFpEF') && !q2.includes('Obesity')) {
						this.rulesThirdStep.ef = true;
						this.rulesFourthStep.SGLTi = true;
						this.rulesFourthStep.sMRA = true;
						this.rulesFourthStep.nsMRA = true;
						this.rulesFourthStep.ARNI = true;
						this.rulesFourthStep['ACEi/ARB'] = true;
					}

					if (q1.includes('HFpEF') && q2.includes('Obesity')) {
						this.rulesThirdStep.ef = true;
						this.rulesFourthStep['GLP1-RA'] = true;
						this.rulesFourthStep.SGLTi = true;
						this.rulesFourthStep.sMRA = true;
						this.rulesFourthStep.nsMRA = true;
						this.rulesFourthStep.ARNI = true;
						this.rulesFourthStep['ACEi/ARB'] = true;
					}
				}

				if (q1.includes('AFF') 
					&& q1.includes('Chronic Kidney Disease') 
					&& q1.includes('ASCVD') 
					&& q1.includes('HF')) {
					this.rulesThirdStep.age = true;
					this.rulesThirdStep.sex = true;
					this.rulesThirdStep.C2VScore = true;
					this.rulesThirdStep.egfr = true;
					this.rulesThirdStep.albuminuria = true;
					this.rulesThirdStep.k = true;
					this.rulesThirdStep.ldlc = true;
					this.rulesThirdStep.scr = true;
					this.rulesThirdStep.ef = true;
				}
			},
			calculate() {
				const questionFirst = this.answers.questionFirst;
				const questionSecond = this.answers.questionSecond;
				const questionThird = this.answers.questionThird;
				const questionFourth = this.answers.questionFourth;

				const C2VScore = this.isValidNumber(questionThird.C2VScore);
				const egfr = this.isValidNumber(questionThird.egfr);
				const albuminuria = this.isValidNumber(questionThird.albuminuria);
				const k = this.isValidNumber(questionThird.k);
				const ldlc = this.isValidNumber(questionThird.ldlc);
				const scr = this.isValidNumber(questionThird.scr);
				const ef = this.isValidNumber(questionThird.ef);
				
				// CALCULDATE AFF
				if (questionFirst.includes('AFF')) {
					this.score.risk = null;
					let countMin = 0;

					if (questionThird.sex != undefined) {
						const sex = questionThird.sex;
						
						if (sex.includes('Male') && C2VScore > 1 && questionFourth.includes('Anticoagulant')) {
							countMin++;
						}

						if (sex.includes('Male') && C2VScore > 1 && !questionFourth.includes('Anticoagulant')) {
							countMin = 0;
						}

						if (sex.includes('Female') && C2VScore > 2 && questionFourth.includes('Anticoagulant')) {
							countMin++;
						}

						if (sex.includes('Female') && C2VScore > 2 && !questionFourth.includes('Anticoagulant')) {
							countMin = 0;
						}
					}

					this.score.score_aff.min = countMin;
					this.score.score_aff.max = 1;
				}

				// CALCULDATE CDK
				if (questionFirst.includes('Chronic Kidney Disease')) {
					this.score.risk = 0;
					this.score.helper = 0;
					let countMin = 0;

					if (questionFourth.includes('GLP1-RA')) countMin++;
					if (questionFourth.includes('SGLTi')) countMin++;
					if (questionFourth.includes('nsMRA')) countMin++;
					if (questionFourth.includes('ACEi/ARB')) countMin++;
					if (questionFourth.includes('ARNI')) countMin++;

					this.score.score_ckd.min = countMin;
					this.score.score_ckd.max = 4;
					
					if ((egfr !== undefined && albuminuria === undefined) || (egfr > 0 && albuminuria == 0)) {
						if (egfr >= 60) {
							this.score.risk = 'CKD is low/moderate risk';
						} else {
							this.score.risk = 'CKD is high/very high risk';
						}

						this.score.helper = 'Consider measuring uACR in this patient';
					} else if ((egfr !== undefined && albuminuria !== undefined) || (egfr > 0 && albuminuria > 0)) {
						if (egfr >= 90 && albuminuria < 30) {
							this.score.risk = 'Low risk';
						} else if ((egfr >= 60 && egfr <= 89) && albuminuria < 30) {
							this.score.risk = 'Low risk';
						} else if ((egfr >= 45 && egfr <= 59) && albuminuria < 30) {
							this.score.risk = 'Moderately increased risk';
						} else if ((egfr >= 30 && egfr <= 44) && albuminuria < 30) {
							this.score.risk = 'High risk';
						} else if ((egfr >= 15 && egfr <= 29) && albuminuria < 30) {
							this.score.risk = 'Very high risk';
						}  else if (egfr < 15 && albuminuria < 30) {
							this.score.risk = 'Very high risk';
						}

						if (egfr >= 90 && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'Moderately increased risk';
						} else if ((egfr >= 60 && egfr <= 89) && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'Moderately increased risk';
						} else if ((egfr >= 45 && egfr <= 59) && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'High risk';
						} else if ((egfr >= 30 && egfr <= 44) && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'Very high risk';
						} else if ((egfr >= 15 && egfr <= 29) && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'Very high risk';
						}  else if (egfr < 15 && (albuminuria >= 30 && albuminuria <= 299)) {
							this.score.risk = 'Very high risk';
						}

						if (egfr >= 90 && albuminuria >= 300) {
							this.score.risk = 'High risk';
						} else if ((egfr >= 60 && egfr <= 89) && albuminuria >= 300) {
							this.score.risk = 'High risk';
						} else if ((egfr >= 45 && egfr <= 59) && albuminuria >= 300) {
							this.score.risk = 'Very high risk';
						} else if ((egfr >= 30 && egfr <= 44) && albuminuria >= 300) {
							this.score.risk = 'Very high risk';
						} else if ((egfr >= 15 && egfr <= 29) && albuminuria >= 300) {
							this.score.risk = 'Very high risk';
						}  else if (egfr < 15 && albuminuria >= 300) {
							this.score.risk = 'Very high risk';
						}
					}
				}

				// CALCULDATE ASCVD
				if (questionFirst.includes('ASCVD')) {
					if (questionSecond.includes('DM') && questionSecond.includes('Obesity')) {
						let countMin = 0;

						if (ldlc >= 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc >= 70 && questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin++;
						}

						if (ldlc >= 70 && !questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin = 0;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (!questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin = 0;
						}

						if (egfr >= 30 && questionFourth.includes('GLP1-RA')) {
							countMin++;
						}

						if (egfr >= 30 && questionFourth.includes('SGLTi')) {
							countMin++;
						}

						this.score.score_ascvd.min = countMin;
						this.score.score_ascvd.max = 4;
					}

					if (questionSecond.includes('DM') && !questionSecond.includes('Obesity')) {
						let countMin = 0;

						if (ldlc >= 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc >= 70 && questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin++;
						}

						if (ldlc >= 70 && !questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin = 0;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (!questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin = 0;
						}

						if (egfr >= 30 && questionFourth.includes('GLP1-RA')) {
							countMin++;
						}

						if (egfr >= 30 && questionFourth.includes('SGLTi')) {
							countMin++;
						}

						this.score.score_ascvd.min = countMin;
						this.score.score_ascvd.max = 4;
					}

					if (!questionSecond.includes('DM') && questionSecond.includes('Obesity')) {
						let countMin = 0;

						if (ldlc >= 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc >= 70 && questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin++;
						}

						if (ldlc >= 70 && !questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT')) {
							countMin = 0;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (questionFourth.includes('Statin') && questionFourth.includes('Additional LLT'))) {
							countMin++;
						}

						if (ldlc < 70 && (!questionFourth.includes('Statin') && !questionFourth.includes('Additional LLT'))) {
							countMin = 0;
						}

						if (egfr >= 30 && questionFourth.includes('GLP1-RA')) {
							countMin++;
						}

						this.score.score_ascvd.min = countMin;
						this.score.score_ascvd.max = 3;
					}
				}

				// CALCULDATE HF
				if (questionFirst.includes('HFrEF/HFmrEF')) {
					if (questionFourth.includes('BetaBlocker')) {
						const riskObj = questionFourth.find(item => typeof item === 'object' && item.BetaBlockerRisk !== undefined);

						const risk = riskObj ? riskObj.BetaBlockerRisk : 0;

						this.score.risk = risk;
					}
				}

				if (questionFirst.includes('HFpEF')) {
					if (questionSecond.includes('Obesity')) {
						let countMin = 0;
						let countFirst = 0;
						let countSecond = 0;
						let countThird = 0;
						let countFourth = 0;

						if (egfr >= 30) countFirst = 1;
						else countFirst = 0;

						if (scr >= 2.5) countSecond = 1;
						else countSecond = 0;

						if (k > 0 && k < 5.5) countThird = 1;
						else countThird = 0;

						if (ef > 0 && ef < 60) countFourth = 1;
						else countFourth = 0;

						if (egfr >= 30 && questionFourth.includes('SGLTi')) {
							countMin++;
						}

						if (egfr >= 30 && questionFourth.includes('GLP1-RA')) {
							countMin++;
						}

						if (scr >= 2.5 && questionFourth.includes('sMRA') || k < 5.5 && questionFourth.includes('sMRA')) {
							countMin++;
						}

						if (scr >= 2.5 && questionFourth.includes('nsMRA') || k < 5.5 && questionFourth.includes('nsMRA')) {
							countMin++;
						}

						if (ef < 60 && questionFourth.includes('ARNI')) {
							countMin++;
						}

						this.score.score_hf.min = countMin;
						this.score.score_hf.max = 5;
					}

					if (questionFourth.includes('BetaBlocker')) {
						const riskObj = questionFourth.find(item => typeof item === 'object' && item.BetaBlockerRisk !== undefined);

						const risk = riskObj ? riskObj.BetaBlockerRisk : 0;

						this.score.risk = risk;
					}

					this.checkboxesSelected = [
						{
							title: "GLP1-RA", 
							fullTitle: 'GLP-1 Receptor Antagonist.',
							type: 'checkbox',
							name: 'checkbox'
						},
						{
							title: "ARNI", 
							fullTitle: 'Angiotension Receptor Neprilysin Inhibitor',
							type: 'checkbox',
							name: 'checkbox'
						},
						{
							title: "SGLTi", 
							fullTitle: 'Sodium Glucose Co-Transporter Inhbitor',
							type: 'checkbox',
							name: 'checkbox'
						},
						{
							title: "nsMRA", 
							fullTitle: 'Non-steroidal Mineralocorticoid Receptor Antagonist',
							type: 'radio',
							name: 'radio-3'
						},
						{
							title: "sMRA", 
							fullTitle: 'Steroidal Mineralocorticoid Receptor Antagonist',
							type: 'radio',
							name: 'radio-3'
						},
					]
				}
			}
		}
	}
